import { storeRequestPromise } from '../idb.js';
export class SchemaStore {
    constructor(db, currentVersion) {
        this.db = db;
        this.currentVersion = currentVersion;
        this.cached = null;
        this.get = async () => {
            if (this.cached) {
                return this.cached;
            }
            const db = this.db;
            const transaction = db.transaction('info', 'readonly');
            const store = transaction.objectStore('info');
            const request = store.get('schema');
            const value = (await storeRequestPromise(request));
            if (!value) {
                return null;
            }
            this.cached = JSON.parse(value.schema);
            return this.cached;
        };
        this.set = async (schema) => {
            const db = this.db;
            const transaction = db.transaction('info', 'readwrite');
            const store = transaction.objectStore('info');
            const request = store.put({
                type: 'schema',
                schema: JSON.stringify(schema),
            });
            this.cached = schema;
            await storeRequestPromise(request);
        };
    }
}
//# sourceMappingURL=SchemaStore.js.map